import type { PropsWithChildren, ReactNode } from 'react';

import { FieldStyled } from './styles/FieldStyled'
import { FieldHelperText } from '../../elements/FieldHelperText'
import { InputLabel } from '../Form/InputLabel'
import { Icon, type IconTypes } from '@ui/elements/Icon'
import { WithTooltip } from '@ui/elements/Tooltip'

export interface IFieldProps {
  layout?: 'horizontal' | 'vertical'
  label?: string | ReactNode
  labelId?: string
  labelFor?: string
  labelTooltipMessage?: string | ReactNode
  labelTooltipAriaLabel?: string
  labelIcon?: IconTypes
  helperText?: string
  error?: boolean
  required?: boolean
}

export const Field = ({
  layout = 'vertical',
  label,
  labelId,
  labelFor,
  labelTooltipMessage,
  labelIcon,
  labelTooltipAriaLabel,
  helperText,
  error,
  required,
  children,
  ...otherProps
}: PropsWithChildren<IFieldProps>) => {
  return (
    <FieldStyled layout={layout} {...otherProps}>
      {label && (
        <InputLabel
          id={labelId}
          htmlFor={labelFor}
          error={error}
          required={required}
        >
          {label}

          {labelIcon && (
            <WithTooltip
              title={labelTooltipMessage}
              placement='top'
              isDisabled={!labelTooltipMessage}
            >
              <Icon
                icon={labelIcon}
                ml={0.25}
                ariaLabel={labelTooltipAriaLabel}
              />
            </WithTooltip>
          )}
        </InputLabel>
      )}

      <div>
        {children}

        {helperText && (
          <FieldHelperText error={error}>{helperText}</FieldHelperText>
        )}
      </div>
    </FieldStyled>
  )
}
